export const dataResolution = [
   {
      title: "Ultra High ≤ 15cm per pixel",
      areaSize: [],
      // value: [0, 15],
      value: "0, 15",
   },
   {
      title: "Super High > 15cm ≤ 30cm per pixel",
      areaSize: [25, 162.6],
      // value: [16, 30],
      value: "16, 30",
   },
   {
      title: "Very High > 30cm ≤ 50cm per pixel",
      areaSize: [25, 2000],
      // value: [31, 50],
      value: "31, 50",
   },
   {
      title: "High > 50cm ≤ 1m per pixel",
      areaSize: [25, 500],
      // value: [51, 100],
      value: "51, 100",
   },
   {
      title: "Medium > 1m ≤ 5m per pixel",
      areaSize: [],
      // value: [101, 500],
      value: "101, 500",
   },
];

export const mockDataWorkFlowGeneralArchive = {
   workflow: {
      id: 2,
      key: "satvu_tasking_order",
      name: "SatVu Tasking Order",
      description: "string",
      type: "order_tasking",
      provider_id: 2,
      version: "1.0.0",
      is_active: true,
      steps: [
         {
            step_id: "step_1",
            next: "step_2",
            submit: {
               url: "https://api.geohub.vn/vmrs/api/v1/orders",
               method: "POST",
               body_template: {
                  order_name: "{order_name}",
                  priority: "{priority}",
                  reason: "{reason}",
                  description: "{description}",
               },
            },
            schema: {
               type: "object",
               required: ["order_name", "priority", "reason"],
               properties: {
                  reason: {
                     type: "string",
                     title: "Reason for Ordering",
                  },
                  priority: {
                     enum: ["HIGH", "LOW", "URGENT"],
                     type: "string",
                     title: "Priority",
                     default: "HIGH",
                  },
                  order_name: {
                     type: "string",
                     title: "Order Name",
                     maxLength: 100,
                     minLength: 1,
                  },
                  description: {
                     type: "string",
                     title: "Description",
                     maxLength: 500,
                  },
               },
            },
            ui: {
               order: ["order_name", "priority", "reason", "description"],
               options: {
                  reason: {
                     title: "Reason",
                     widget: "textarea",
                     required: true,
                     placeholder: "Explain why you need this imagery",
                  },
                  priority: {
                     title: "Priority",
                     widget: "select",
                     default: "low",
                     options: [
                        {
                           lable: "High",
                           value: "high",
                        },
                        {
                           lable: "Low",
                           value: "low",
                        },
                        {
                           lable: "Urgent",
                           value: "urgent",
                        },
                     ],
                     required: true,
                  },
                  order_name: {
                     title: "Order name",
                     widget: "input",
                     required: true,
                     placeholder: "Enter order name",
                  },
                  description: {
                     title: "Description",
                     widget: "textarea",
                     required: false,
                     placeholder: "Optional description",
                  },
               },
            },
            name: "General Information Form",
         },
      ],
   },
};

export const mockDataWorkFlowSatvuArchive = {
   workflow: {
      id: 1,
      key: "satvu_archive_order",
      name: "Satvu order archive",
      description: "Satvu order archive",
      type: "order_archive",
      provider_code: "satvu",
      version: "1.0.0",
      is_active: true,
      steps: [
         {
            step_id: "step_1",
            submit: {
               url: "https://api.geohub.vn/vmrs/api/v1/orders",
               method: "POST",
               body_template: {
                  type: "archive",
                  item_ids: "{item_ids}",
               },
            },
            schema: {
               type: "object",
               title: "Search images",
               $schema: "http://json-schema.org/draft-07/schema#",
               required: ["name"],
               properties: {
                  name: {
                     type: "string",
                     title: "Order name",
                     required: false,
                     placeholder: "Order name",
                  },

               },
            },
            ui: {
               order: ["name"],
               options: {
                  name: {
                     title: "Order name",
                     widget: "input",
                     can_edit: true,
                     required: true,
                     placeholder: "Enter order name",
                  },

               },
            },
         },
      ],
      created_at: "2026-04-20T08:57:15.368343+00:00",
      updated_at: "2026-04-20T08:57:15.368349+00:00",
   },
};

export const mockDataWorkFlowPlanetArchive = {
   workflow: {
      id: 1,
      key: "satvu_archive_order",
      name: "Satvu order archive",
      description: "Satvu order archive",
      type: "order_archive",
      provider_code: "satvu",
      version: "1.0.0",
      is_active: true,
      steps: [
         {
            step_id: "step_1",
            submit: {
               url: "https://api.geohub.vn/vmrs/api/v1/orders",
               method: "POST",
               body_template: {
                  type: "archive",
                  item_ids: "{item_ids}",
               },
            },
            schema: {
               type: "object",
               title: "Search images",
               $schema: "http://json-schema.org/draft-07/schema#",
               required: ["name"],
               properties: {
                  name: {
                     type: "string",
                     title: "Order name",
                     required: false,
                     placeholder: "Order name",
                  },

               },
            },
            ui: {
               order: ["name"],
               options: {
                  name: {
                     title: "Order name",
                     widget: "input",
                     can_edit: true,
                     required: true,
                     placeholder: "Enter order name",
                  },

               },
            },
         },
      ],
      created_at: "2026-04-20T08:57:15.368343+00:00",
      updated_at: "2026-04-20T08:57:15.368349+00:00",
   },
};

export const mockDataWorkFlowPAxelGlobeArchive = {
   workflow: {
      id: 1,
      key: "satvu_archive_order",
      name: "Satvu order archive",
      description: "Satvu order archive",
      type: "order_archive",
      provider_code: "satvu",
      version: "1.0.0",
      is_active: true,
      steps: [
         {
            step_id: "step_1",
            submit: {
               url: "https://api.geohub.vn/vmrs/api/v1/orders",
               method: "POST",
               body_template: {
                  type: "archive",
                  item_ids: "{item_ids}",
               },
            },
            schema: {
               type: "object",
               title: "Search images",
               $schema: "http://json-schema.org/draft-07/schema#",
               required: ["name"],
               properties: {
                  name: {
                     type: "string",
                     title: "Order name",
                     required: false,
                     placeholder: "Order name",
                  },

               },
            },
            ui: {
               order: ["name"],
               options: {
                  name: {
                     title: "Order name",
                     widget: "input",
                     can_edit: true,
                     required: true,
                     placeholder: "Enter order name",
                  },

               },
            },
         },
      ],
      created_at: "2026-04-20T08:57:15.368343+00:00",
      updated_at: "2026-04-20T08:57:15.368349+00:00",
   },
};

export const exampleData = [
   [
      {
         stac_version: "1.0.0",
         bbox: "",
         collection: "PNEO",
         type: "",
         links: [
            {
               type: "HTTP",
               sub_path:
                  "/api/v1/access/thumb?provider_id=4&url=https://access.foundation.api.oneatlas.airbus.com/api/v1/items/09352b47-9a95-472f-b4d5-f1916c1a784c/thumbnail",
               rel: "thumbnail",
               href: "https://dev-api.geohub.ai/vmrs/api/v1/access/thumb?provider_id=4&url=https://access.foundation.api.oneatlas.airbus.com/api/v1/items/09352b47-9a95-472f-b4d5-f1916c1a784c/thumbnail",
            },
         ],
         geometry: {
            coordinates: [
               [
                  [32.9328549391, 24.0553771974],
                  [32.7585707883, 24.0265156376],
                  [32.7588289556, 23.8965943446],
                  [32.9324946865, 23.923857403],
                  [32.9328549391, 24.0553771974],
               ],
            ],
            type: "Polygon",
         },
         id: "ACQ_PNEO3_06922204720583",
         stac_extensions: [
            "https://stac-extensions.github.io/sar/v1.0.0/schema.json",
            "https://stac-extensions.github.io/raster/v1.1.0/schema.json",
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.1.0/schema.json",
            "https://landsat.usgs.gov/stac/landsat-extension/v1.1.1/schema.json",
            "https://stac-extensions.github.io/classification/v1.0.0/schema.json",
            "https://stac-extensions.github.io/scientific/v1.0.0/schema.json",
         ],
         properties: {
            "landsat:scene_id": "",
            "landsat:wrs_row": "",
            "landsat:cloud_cover_land": "",
            description: "",
            platform: "PNEO3",
            "landsat:wrs_path": "",
            "landsat:collection_number": "",
            "view:sun_elevation": "",
            datetime: "2026-03-16T08:36:00.571Z",
            instruments: "",
            "proj:shape": "",
            "eo:cloud_cover": 0,
            "landsat:correction": "",
            "sci:doi": "",
            "oneatlas:id": "09352b47-9a95-472f-b4d5-f1916c1a784c",
            created: "2026-03-16T10:23:45.337191327Z",
            "landsat:wrs_type": "",
            "view:sun_azimuth": 140.31056310469066,
            "view:off_nadir": 37.21254673421324,
            "sar:polarizations": "",
            "proj:epsg": "",
            "proj:transform": "",
            gsd: 0.3,
            "landsat:collection_category": "",
         },
         provider_id: 4,
         provider_name: "Oneatlas",
      },
      {
         stac_version: "1.0.0",
         bbox: [110.3199435, 21.0648901, 110.44258295, 21.26102181],
         collection: "capella-slc",
         type: "",
         thumbnail_sub_path:
            "/api/v1/access/thumb?provider_id=3&url=aHR0cHM6Ly9jaXJydXMtcHJvZC1kYXRhLTI3cWk0a2phN284NC5zMy51cy13ZXN0LTIuYW1hem9uYXdzLmNvbS9jYXBlbGxhLXFhLzIwMjYvMy8xOS9DQVBFTExBX0MxN19TTV9HRU9fSEhfMjAyNjAzMTkwNjIxMzdfMjAyNjAzMTkwNjIxNDEvQ0FQRUxMQV9DMTdfU01fR0VPX0hIXzIwMjYwMzE5MDYyMTM3XzIwMjYwMzE5MDYyMTQxX3RodW1iLnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1Db250ZW50LVNoYTI1Nj1VTlNJR05FRC1QQVlMT0FEJlgtQW16LUNyZWRlbnRpYWw9QVNJQTROVjNFUkVXMkdPR1Y1VE8lMkYyMDI2MDMxOSUyRnVzLXdlc3QtMiUyRnMzJTJGYXdzNF9yZXF1ZXN0JlgtQW16LURhdGU9MjAyNjAzMTlUMTAwMDQwWiZYLUFtei1FeHBpcmVzPTM2MDAmWC1BbXotU2VjdXJpdHktVG9rZW49SVFvSmIzSnBaMmx1WDJWakVGSWFDWFZ6TFhkbGMzUXRNaUpHTUVRQ0lCNnRyUXYwWG1hckxZNTFUc2RjZDlHd0NLQW81MEtOYnlweTBvJTJCdGwlMkZYJTJCQWlBU1BZUVFCOTBwRSUyQmtydVIxdWdyWkE1c1prVHFJeTRYNXQ0d216eHUlMkZ5JTJCQ3FLQkFnYkVBSWFERGcxTkRBeE56SXhORGMyTlNJTTF3WFlQNE5CWTJ0eGhZYVNLdWNEVWQ0Nklra3VWYjJ4WmpNQlFhVVNBYmgyelJNeWVJbFVvUzBucmQ1Qjc3VHdQaHBscklmVVl4R0Z2NmxDQkxuWUklMkZiN3VpMiUyRmluYXpmRHVCa0FPREdYMlNVZXdQTjhUOFlnWEFWOUhJZ0xZTVBrR2dYJTJGcTFNRWtDSWJkMzBsRzZxWDZ6SG1BanclMkZUVkolMkJtMkVaeVR3VEpmSWg3RlFHU05XZU1lNzY1cmVydXhBdGg5NHZ4cllpTjZVczhKbjQxSDBaSXJtVHI3SEMlMkZyd2FxTXdpQWNQeHFoNSUyRiUyRnpqRFpNRUdpa2pzYWpITDROdGRmNiUyQlFlR3N4RWJWVEl6dHpTSGFnWDZ2THZucFFMM2wyR1gzSjZvN240YnlaNVdxYUozT2liZyUyRmR1ZHdwWXFDblQwZENReWZoWVdocmlFb3VDcmFXMTV4eUhSJTJCMmVYMTB3MlRSSVpzSjl2MWFjcmdVaVNxS3J0M0NNVTJlWTE0RzdYM1h5JTJCT1JaOWNmT1liME9JaVRxUEc0N2xFb2tjWkVjUkpuQjdIZGNiYkJDdkF4ZTJyVmZVcFAwbmttJTJGQU1BcXR0dmNnZ1JYVXdhVTglMkJDSlplc2VGTUE3bzNEZVJwem5xekNlczRxOTBUVzlVYzAzdThqJTJGTkJpMzEzbExnOEtXJTJGUEI0R2VqM09Na3daazRTT21LMkZFeTZWajIxSjJVZENreW5kU2p6NlklMkJDeTZKMFBHVVA4ZUMxRUh4aTQxcXl1amhpcXM4UFo0Zm9mcHlzS0NXSkltWm42azRrcXlpcTF1Vm0xd01zTyUyRnJxYkNvZ3lYTmJITGZ3ekxLbDFaQVRQd1RrJTJGbmZHRTAwR1d0M2l3cFFLNVY1WTdIRERMa2UlMkZOQmpxakFRbVIlMkJSS2h1YmZlNFI1bGlwSHMxMzVhWkV0NWpwc0xEWWRObVd3ZnJRenR4JTJGUkJoT0xYQkFOUEZ6ZUdPazF0T1VRaFBvVlFESyUyQkRWbGFBbU9tcEM0MDltanVHc1VGYU5ISXhqM1dNUlB3dlA1Wm9BJTJCWk4lMkZ6aXBUZk5qM0lZWWphVkg3cmJzZkwxQnZWRGpnYmRVQUlkUTBya2N6OEZWSDNQWUp0bUhYWktLUUdaRWczMmJrbSUyQm1yc1dqOUk1MnN6VFIweVFGMmh0dThad0JGaWQ5VWVTZTJtTSUzRCZYLUFtei1TaWduYXR1cmU9NDk3MDZkMjkzYTUyN2YzNjQ5MWU1MGEyZjc2NGFlZjZiMTg4MTFkZmM0NTcxYzQ2NWExMDc4N2QxMGQ2ZjIyMiZYLUFtei1TaWduZWRIZWFkZXJzPWhvc3QmeC1pZD1HZXRPYmplY3Q=&is_b64_encode=true",
         links: [
            {
               type: "image/png",
               sub_path:
                  "/api/v1/access/thumb?provider_id=3&url=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&is_b64_encode=true",
               rel: "thumbnail",
               href: "https://dev-api.geohub.vn/vmrs/api/v1/access/thumb?provider_id=3&url=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&is_b64_encode=true",
            },
         ],
         geometry: {
            coordinates: [
               [
                  [110.36766062, 21.26102181],
                  [110.44258295, 21.24330289],
                  [110.39478245, 21.0648901],
                  [110.3199435, 21.08257622],
                  [110.36766062, 21.26102181],
               ],
            ],
            type: "Polygon",
         },
         id: "CAPELLA_C17_SM_SLC_HH_20260319062137_20260319062141",
         stac_extensions: [
            "https://stac-extensions.github.io/sar/v1.0.0/schema.json",
            "https://stac-extensions.github.io/raster/v1.1.0/schema.json",
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.1.0/schema.json",
            "https://landsat.usgs.gov/stac/landsat-extension/v1.1.1/schema.json",
            "https://stac-extensions.github.io/classification/v1.0.0/schema.json",
            "https://stac-extensions.github.io/scientific/v1.0.0/schema.json",
         ],
         properties: {
            "landsat:scene_id": "",
            "landsat:wrs_row": "",
            "landsat:cloud_cover_land": "",
            description: "",
            platform: "capella-17",
            "landsat:wrs_path": "",
            "landsat:collection_number": "",
            "view:sun_elevation": "",
            datetime: "2026-03-19T06:21:39.583687Z",
            instruments: ["capella-radar-17"],
            "proj:shape": "",
            "eo:cloud_cover": "",
            "landsat:correction": "",
            "sci:doi": "",
            created: "2026-03-19T07:31:25.331Z",
            "landsat:wrs_type": "",
            "view:sun_azimuth": 1,
            "view:off_nadir": 51.5,
            "sar:polarizations": ["HH"],
            "proj:epsg": "",
            "proj:transform": "",
            gsd: 0.85,
            "landsat:collection_category": "",
            "capella:id": "CAPELLA_C17_SM_SLC_HH_20260319062137_20260319062141",
         },
         provider_id: 3,
         provider_name: "Capella",
      },
   ],
];

export const exampleDataDowloadUrl = {
   message: "Download URL retrieved successfully",
   data: {
      type: "OrderItemDownloadUrl",
      url: "https://test-api.geohub.ai/vmrs/api/v1/orders/example",
      ttl: 3600,
   },
};

export const exampleFormSearchByImageType = {
   message: "Form config retrieved successfully",
   data: {
      provider_id: 1,
      id: 5,
      form_schema: {
         schema: {
            type: "object",
            title: "Search images",
            $schema: "http://json-schema.org/draft-07/schema#",
            required: [
               "date_from",
               "date_to",
               "gsd",
               "cloud_cover",
               "off_nadir",
               "geometry",
            ],
            properties: {
               gsd: {
                  enum: [
                     "ultral-hight",
                     "super-hight",
                     "very-hight",
                     "hight",
                     "medium",
                  ],
                  type: "string",
                  title: "GSD",
                  default: "gsd",
                  required: false,
               },
               date_to: {
                  type: "string",
                  title: "Date Range",
                  pattern: "^\\d{4}-\\d{2}-\\d{2}.*/.*\\d{4}-\\d{2}-\\d{2}.*$",
                  can_edit: true,
                  description: "ISO 8601 datetime range",
               },
               geometry: {
                  type: "object",
                  title: "Area of Interest",
                  required: ["type", "coordinates"],
                  properties: {
                     bbox: {
                        type: "array",
                        items: {
                           type: "number",
                        },
                        title: "Bounding Box",
                        maxItems: 4,
                        minItems: 4,
                     },
                     type: {
                        enum: ["Point", "Polygon"],
                        type: "string",
                        title: "Geometry Type",
                     },
                     coordinates: {
                        type: "array",
                        items: {
                           type: "number",
                        },
                        title: "Coordinates",
                        minItems: 2,
                     },
                  },
               },
               date_from: {
                  type: "string",
                  title: "Date Range",
                  pattern: "^\\d{4}-\\d{2}-\\d{2}.*/.*\\d{4}-\\d{2}-\\d{2}.*$",
                  can_edit: true,
                  description: "ISO 8601 datetime range",
               },
               off_nadir: {
                  type: "number",
                  title: "Off-Nadir (°)",
                  default: 0,
                  maximum: 45,
                  minimum: 0,
                  required: false,
               },
               cloud_cover: {
                  type: "number",
                  title: "Cloud Cover (%)",
                  default: 15,
                  maximum: 100,
                  minimum: 0,
                  required: true,
               },
            },
         },
      },
      ui_schema: {
         ui: {
            order: [
               "resolution-swith",
               "date_from",
               "date_to",
               "gsd",
               "cloud_cover",
               "off_nadir",
               "geometry",
            ],
            options: {
               gsd: {
                  title: "GSD",
                  widget: "select",
                  default: "ultra-high",
                  options: [
                     {
                        label: "Ultra high <= 15cm per pixel",
                        value: "ultral-high",
                     },
                     {
                        label: "Super high > 15cm <= 30cm per pixel",
                        value: "super-high",
                     },
                     {
                        label: "Very high > 30cm <= 50cm per pixel",
                        value: "Very-high",
                     },
                     {
                        label: "High > 50cm <= 1m per pixel",
                        value: "high",
                     },
                     {
                        label: "Medium > 1m <= 5m per pixel",
                        value: "medium",
                     },
                  ],
                  depField: "resolution-swith",
                  required: false,
               },
               date_to: {
                  title: "Date to",
                  widget: "date-picker",
                  required: true,
               },
               geometry: {
                  title: "Geometry",
                  widget: "geo-json-editor",
                  required: true,
                  supportedTypes: ["Point", "Polygon"],
               },
               date_from: {
                  title: "Date from",
                  widget: "date-picker",
                  required: true,
               },
               off_nadir: {
                  max: 45,
                  min: 0,
                  title: "Off-Nadir (°)",
                  widget: "range_minmax",
                  defaultMin: 15,
                  defaultMax: 35,
                  depField: "resolution-swith",
                  required: false,
               },
               cloud_cover: {
                  max: 100,
                  min: 0,
                  step: 5,
                  title: "Cloud Cover (%)",
                  widget: "range_minmax",
                  defaultMin: 15,
                  defaultMax: 45,
                  required: true,
               },
               "resolution-swith": {
                  title: "Resolution (GSD) or Off nadir",
                  widget: "radio",
                  default: "gsd",
                  options: [
                     {
                        label: "Resolution (GSD)",
                        value: "gsd",
                     },
                     {
                        label: "Off_nadir",
                        value: "off_nadir",
                     },
                  ],
                  required: false,
               },
            },
         },
      },
      version: "1.0.0",
      is_active: true,
      updated_at: "2026-03-31T03:50:24.597424",
      key: "search_image_archive:thermal",
      name: "This order search image thermal",
      description: "string",
      created_at: "2026-03-31T03:50:24.597417",
   },
};

export const topMenu = {
   config: {
      icon: {
         name: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAeeSURBVHgBzVpLbBNXFL1vZvxNSJzwawARRyqgVC2ktAtApaKLVixAfLqpCkjppixAot100S6ARRdlA0hlQTelAqlUaiGILJC6IIUFK6oAlQIpbZwQEpLm4yT+2zOv9zxnHMc4ie2YJEeyPJ4Zz7vn3XPve+++EVQm/N0f3WVKs0mT+hZJsokE+fi0f+oOGSQpAnw+kLLorlMXf26o87RRGSBoHoDhiZR10NDpiNep+1wOQS6HTk5DI10jcuhTj7csSQmTKGVaFOWDeFJSJGEGhaQWoWk/zYdQSSRgvJTypMep7apw61Tt0UnTin9U0pRMyKKhiSSTkwFhWac3rqu8REWiqJY7B0NNlNLOwvjaZQ7yOjUqFyJM5kUwochYQnzQWOcJULnR+SJ2gj0gR0JJ+SoxFknJfwaikts6Wahtc3qiq0v6kq7odfT+ap9zms5fFSAzeIWl1uKMez5raBDB2e6f1aKO/qhfk/J2TYXhX1nloIXGcChFwxPJOeU1IwmbwPJlDv/ySoMWC4UQmTEyNUteX2wCANqHHbAH0s53T14SnX2RszWVRtNiE7ABO6q8RhPHZmHB3tkfav6Xs4NpWnIpAfYgaz3pC+/PtXlaTNhx0LDK7V+ILFQsMJb0DseDnLEasjPWNDnpZJ2s8uhLkgCAwZUzpS/hjHyRfT5DAl4wNK2Zg0j97p5I0dG2QXo4FKelgGDcUt+ID10XJ7KDPEMCXuABLTOY1S8zqNql0bZrz6jx5wBd6RxXxBYDd/qimWPM0Xze6d7I6OZJX6QrNxbGWIPbfu2h7tCU8Uc2VtGhjcvo/TUeWghcfjLObXlVp9rAjPjpQCy46QfPcjolLJEmEN7PU+nr65a78j4Irnw4HKeeUFJ5A8fVTp22rHDSnvrKaQ2Um0APd+A379S+dO0Z2xBOSgyAbap1IWhflVef8WE9PFX+5Pd+NjytvnqOG3gJpODqvf4KOsweKgcQg5tXuBSB1u4w/fJRXd77KnkJEInFkW7blCce90Ye1K92bXYbM0+tv38UpK/uDaljH5NBvPhcOq3nQINXHo3E2WMm7azzqus7WW4gbcsO3gTxdCekPYcOwL3rJzsFcYfOuBkI0QVu79bedTN6GZPErsFYYNMab4Po6hr1pTzu0ddXu2kuQEp4KL7H2OCHbDga7x5PKVIwICM7PheEt9iLMBLSO7Qhfb01EFbPO/aWTxG98Fc65UM2394fUR94AB6eDU9fxMiIuWuMlNvd5DYKGxdAYPtvz+jBcDzvtSssASSBLSyH917zMKl0AkCPw/A3rgZUDMFY3I/zR/8YoGNv+ug4E7IJ4PpcBAAnOylekfQbkky/oRc+zb64axXtvvlc9TIM3FmX/uDYDnjbQBiOWIKUcP3ewfUZT+5ufa70f5V7HNdsAvUsz3yBnJ+ERvFwosmQlihqhN7MGQwNI7hhkJ25lFH8jev4tgcnGPj11lr1jXMwFPKpdmh07+M0KZsA4gNxUCh0HjMsTfOVlBthEHrzcx7RW7tDGYNtwECQsY0HbOngfzh39cM6TgxahgBwZseKotI1ahNCSl/JCR4G3O2LZAgoGbxb+1KqVdMXNt4edY+z/mEskE0A/ys1TRtSiCBPuqlYVE+6fvfNXjq8qUoFJ4iBFORiax/HNtEz21eoAM4lgA7AtVJhaMIKmpZOpQCGdnzqz/zOlkw2oHU7gIFsAgA6Ax1QLDBWsJwCBpnO9njKovkCM97LPFhlA6k2GDOnDVq5BOx0Wwq4RkWmrgcMRzIcSBpzD3RzoZsHuGzAuNxUmUsAY0Gh6TQfYlwKdcfc7VpDQ02QZ4UB1EjnA4yw9ZNrcujbNg7SwieXQDoOVlKpiCctlpP5CCs81aq0rBsTMetETUXpZUk70Lt5mmFrPz2o9aqpSW4aPrNj5bxmvyhIG0K/j2NltdT1lhBrd76AUbkE8J1LoNBpxWwYj6Z4p8C6gWNFovGi+w6X2yErKgdg+PZrPXlXgsVMK2YCshIXDXgGW9GC32n98OqIJJ0fDZdn+Yl0iVE7F/BSMdOKmcAVQU6tos3+nWnJmUicC0ZSZfGGHR++rNI/RuNbe9bOexU46QUyNTptn8u0gixlmvL8UKg83oCx302OwuWQkA14wUzRpey67LRuUd4I0wle+vnKsYFyhKcjWCODUDnW4fDCeNQMWJo4PeuNKBos5TJmR2+0mQrB497Quf7RuFxKGBxLSNiVz968qyGsu5Mu5+3aSkeTXRFcTCAOhidS7ZvWet/Odz2v8FWQC+0Ab3AE8IDFhCLAdnAcHJjpnoK2u7j+6V8Mj/w3niQeu0rf7rIBaSVcrh+5Trv/tQXceBxIbzy2OeKeA3NtPBaMjufhU8haY+FXuwWMLWZsNT/um16+nw1FdastL/aGH9vB5d6MH2H9o/fJsL7cuKqyvdD/lqQNJtPMZE6CDPYLPFzOLEVmmOKMRU0K8wwaxptCnG4s4R2PeQmcyezSpNXMh/vsF1Q8XDwzuKLo5HpK9vse0LnJBYkErwPiyakXVFImXdYM7VrjQr+gkg8gZJlyKxfldgqSfqleExLZW7YBoV4X0totIR9wlaW9sUyvCv0PxJyHy/GlJpAAAAAASUVORK5CYII=",
         type: "embed_base64",
      },
      title: "VMRS",
   },
   menu: [
      {
         active: true,
         id: "vmrs_cbd_user",
         items: [
            {
               active: false,
               icon: {
                  name: "/svg/home.svg",
                  type: "static",
               },
               id: "vmrs_home",
               label: {
                  lang_key: "siderbar.home",
               },
               role: ["user"],
               route: "/home",
            },
            {
               active: false,
               id: "divider",
            },
            {
               active: true,
               icon: {
                  name: "/svg/tasking-map.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_explore_tasking",
               label: {
                  lang_key: "siderbar.exploreTaskingOrders",
               },
               role: ["user"],
               route: "/explore-tasking",
            },
            {
               active: true,
               icon: {
                  name: "/svg/order-tasking.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_tasking_order",
               label: {
                  lang_key: "siderbar.taskingOrders",
               },
               role: ["user", "admin"],
               route: "/order/management-tasking",
            },
            {
               active: true,
               id: "divider",
            },
            {
               active: true,
               icon: {
                  name: "/svg/Explore.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_explore_archive_image",
               label: {
                  lang_key: "siderbar.existingImages",
               },
               role: ["user"],
               route: "/explore-archive",
            },
            {
               active: true,
               icon: {
                  name: "/svg/mangae-archive-order.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_archive_orders",
               label: {
                  lang_key: "siderbar.orderExistingImages",
               },
               role: ["user", "admin"],
               route: "/order/management-order",
            },
            {
               active: true,
               icon: {
                  name: "/svg/feedback.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_feedback",
               label: {
                  lang_key: "siderbar.feedbacks",
               },
               role: ["admin"],
               route: "/feedbacks",
            },
            {
               active: true,
               icon: {
                  name: "/svg/iconBranch.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_provider_branch",
               label: {
                  lang_key: "siderbar.providerBranch",
               },
               role: ["admin"],
               route: "/provider-branch",
            },
            {
               active: true,
               icon: {
                  name: "/svg/menuMap.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_basemapSetting",
               label: {
                  lang_key: "siderbar.basemapSetting",
               },
               role: ["admin"],
               route: "/basemapSetting",
            },
            {
               active: true,
               icon: {
                  name: "/svg/iconOrganization.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_organizations",
               label: {
                  lang_key: "siderbar.organizations",
               },
               role: ["admin"],
               route: "/organizations",
            },
         ],
         label: {
            lang_key: "menu.vmrs_cbd_user",
         },
         redirect_page: [
            {
               name_element: "Map",
               role: "user",
            },
            {
               name_element: "ManagementOrderPage",
               role: "admin",
            },
         ],
      },
   ],
};

export const bottomMenu = {
   menu: [
      {
         active: true,
         id: "vmrs_user_bottom_menu",
         items: [
            {
               active: false,
               icon: {
                  name: "/svg/notification.svg",
                  type: "static",
               },
               id: "vmrs_cbd_user_bottom_menu_noti",
               label: {
                  lang_key: "siderbar.notification",
               },
               onClick: "handleClickMenuNoti",
               total: "{totalNoti?.length}",
            },
            {
               active: true,
               icon: {
                  name: "/svg/Order.svg",
                  type: "static",
               },
               id: "vmrs_user_bottom_menu_cart",
               label: {
                  lang_key: "siderbar.cart",
               },
               onClick: "handleClickMenuCart",
               role: ["user"],
               total: "{arrIdImage?.length}",
            },
            {
               acrossUrl: "{publicConfig?.REACT_APP_ENDPOINT_ACCOUNT}",
               active: true,
               icon: {
                  name: "/svg/profile-circle.svg",
                  type: "static",
               },
               id: "vmrs_user_bottom_menu_account",
               label: {
                  lang_key: "siderbar.account",
               },
            },
         ],
         label: {
            lang_key: "menu.vmrs_user_bottom_menu",
         },
      },
   ],
};
